module.exports = "<div class=\"dialog rounded-0\">\n  <div class=\"dialog-header border-0 m-auto\">\n    <div class=\"spinner-border text-primary\" role=\"status\">\n      <span class=\"sr-only\"></span>\n    </div>\n  </div>\n\n  <div class=\"dialog-content border-0 m-auto\">\n    <div class=\"text-center mb-1 dialog-text title\">\n      Loading...\n      <br>\n      This may take few minutes depending on the file size...\n    </div>\n  </div>\n</div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/loader/loader.component.html
// module id = ./src/app/shared/components/loader/loader.component.html
// module chunks = main